import type { EmployeeAlertLastWorkingDateBeforeHiredDate } from '@/common/graphql';

import { DateWithCount } from '../DateWithCount';
import { FormattedDate } from '../FormattedDate';

export const DetailDescriptionEmployeeAlertLastWorkingDateBeforeHiredDate = ({
  reason,
}: {
  reason: Pick<EmployeeAlertLastWorkingDateBeforeHiredDate, 'hiredDate' | 'lastWorkingDate'>;
}) => (
  <>
    <div>
      <FormattedDate prefix="Hired date" date={reason.hiredDate} />
    </div>
    <div>
      <DateWithCount prefix="Last working date" date={reason.lastWorkingDate} />
    </div>
  </>
);
